<template>
  <div v-if="mode == 'view'">{{ label_ }} </div>

  <el-autocomplete
    v-if="mode != 'view'"
    :fetch-suggestions="querySearchAsync"
    v-model="model.displayName"
    highlight-first-item
    @change="selectChange"
    value-key="personName"
    :trigger-on-focus="false"
    style="width: 100%"
    @select="selectEnterprise"
  >
    <template #append>
      <el-button type="primary" icon="el-icon-search" @click="model.visible = true"></el-button>
    </template>
    <template #default="{ item }"> {{ `${item.personName}(${item.envNum})` }}{{ item.areaCodeName ? `-${item.areaCodeName}` : '' }} </template>
  </el-autocomplete>
  <td-dialog
    title="执法人员选择"
    icon="el-icon-search"
    :show-full-screen="false"
    fullscreen
    v-model="model.visible"
    no-ok-button
    no-padding
    no-scrollbar
    @closed="closed"
    cancelText="关闭"
  >
    <td-list
      ref="listRef"
      v-model:query-model="model.list.queryModel"
      v-model:data="model.list.data"
      :cols="cols"
      :open-toosl-bar="false"
      fixed
      :action="model.list.action"
    >
      <template #querybar>
        <el-form-item label="区域：" prop="areaCode" more>
          <td-region-select-v2 v-model="model.list.queryModel.areaCode" :isLimit="false" check-strictly></td-region-select-v2>
        </el-form-item>
        <el-form-item label="执法人员名称：" prop="personNameLike">
          <el-input v-model="model.list.queryModel.personNameLike"></el-input>
        </el-form-item>
        <el-form-item label="环境监察执法证件号：" prop="envNumLike">
          <el-input v-model="model.list.queryModel.envNumLike"></el-input>
        </el-form-item>
        <el-form-item label="地方行政执法证件号：" prop="lawNumLike">
          <el-input v-model="model.list.queryModel.lawNumLike"></el-input>
        </el-form-item>
      </template>
      <template #col-button-choice="{ row }">
        <el-button type="text" icon="el-icon-select" @click="selectEnterprise(row)">选择</el-button>
      </template>
    </td-list>
  </td-dialog>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watchEffect } from 'vue'
import { getList, detail } from '../../../api/userEnvironment'
import { nextTick } from 'vue'

const props = defineProps({
  modelValue: {
    type: [Object, String, Number, Array],
    default: ''
  },
  visible: {
    type: Boolean,
    default: false
  },
  //传入对象时id
  idStr: {
    type: String,
    default: 'id'
  },
  /**是否多选 */
  multiple: {
    type: Boolean,
    default: false
  },
  /**行政区划 */
  areaCode: {
    type: String,
    default: ''
  },
  mode: {
    type: String,
    default: 'edit'
  },
  manageLevel: {
    type: String,
    default: ''
  },
  supervisionTypes: {
    type: [String, Number],
    default: ''
  },
  size: {
    type: Number,
    default: 5
  },
  //自定义校验
  validator: {
    type: Function,
    default: null
  }
})
const model = reactive({
  displayName: '',
  visible: false,
  /**列表页模型 */
  list: {
    queryModel: {},
    data: [],
    action: {
      query: getList
    }
  }
})
let cacheData = []
const closed = () => {
  model.list.queryModel.personNameLike = ''
  model.list.queryModel.envNumLike = ''
  model.list.queryModel.areaCode = ''
  model.list.queryModel.lawNumLike = ''
}
const emit = defineEmits(['update:modelValue', 'update:visible', 'change'])
const cols = reactive([
  {
    label: '姓名',
    prop: 'personName',
    align: 'center'
  },
  {
    label: '行政区划',
    prop: 'areaCodeName',
    align: 'center'
  },
  {
    label: '环境监察执法证件号',
    prop: 'envNum',
    align: 'center'
  },
  {
    label: '地方行政执法证件号',
    prop: 'lawNum',
    align: 'center'
  },
  {
    type: 'buttons',
    label: '操作',
    buttons: ['choice'],
    width: 80,
    align: 'center'
  }
])
const listRef = ref(null)
const changeName = val => {
  emit('update:modelValue', val)
}
const flag = ref(false)
const selectEnterprise = row => {
  flag.value = true

  if (props.validator) {
    if (!props.validator(row)) {
      model.displayName = ''
      nextTick(() => {
        flag.value = false
      })
      return
    }
  }
  model.displayName = row.personName
  model.visible = false
  emit('update:modelValue', model.displayName)
  emit('change', row)
  nextTick(() => {
    flag.value = false
  })
}
const selectChange = val => {
  if (!flag.value) {
    if (!cacheData.find(e => e.personName == val)) {
      model.displayName = ''
      emit('update:modelValue', '')
      emit('change', {})
    }
  }
}
const label_ = computed(() => props.modelValue)

const querySearchAsync = async (keyWord, callback) => {
  if (keyWord == '') {
    cacheData = []
    callback([])
    return
  }
  let result = await getList({ personNameLike: keyWord })
  if (result.code == 200) {
    if (result.data.records.length == 1) {
      cacheData = result.data.records
      callback(result.data.records)
    } else {
      cacheData = result.data.records
      callback(result.data.records)
    }
  } else {
    cacheData = []
    callback([])
  }
}
onMounted(() => {
  if (props.modelValue) {
    model.displayName = props.modelValue
  }
})
</script>
<script>
export default {
  name: 'PersonSelect',
  cname: '人员信息选择',
  viewDisplay: true
}
</script>
<style lang="scss">
.td-tips-penalize-underline::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  bottom: 0;
  border-bottom: 1px solid var(--el-link-default-active-color);
  border-color: var(--el-link-text-color);
}
</style>
